export const drawerItemsMain = [
  {
    key: "Production Dashboard",
    title: "productionDashboard",
    routes: [
      {
        nav: "ScanDashboard",
        routeName: "ScanDashboard",
        title: "productionDashboard",
      },
    ],
  },
  {
    key: "ScanByManager",
    title: "scanResults",
    routes: [
      {
        nav: "ScanByManager",
        routeName: "ScanByManager",
        title: "scanResults",
      },
    ],
  },
];
